const NUMERIC_REGEX = /^-?\d+(\.\d+)?$/;

export const roundTo = (value: number, decimals = 2) => Math.round(value * 10 ** decimals) / 10 ** decimals;

const normalizeScalar = (value: unknown, decimals: number): unknown => {
  if (typeof value === "number") return roundTo(value, decimals);

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (NUMERIC_REGEX.test(trimmed)) {
      return roundTo(Number(trimmed), decimals);
    }
  }

  return value;
};

export const normalizeNumericDeep = (input: unknown, decimals = 2): unknown => {
  if (input === null || typeof input !== "object") {
    return normalizeScalar(input, decimals);
  }

  const stack: unknown[] = [input];

  while (stack.length) {
    const current = stack.pop() as Record<string, unknown>;

    if (Array.isArray(current)) {
      for (let i = 0; i < current.length; i++) {
        const value = current[i];
        if (value && typeof value === "object") {
          stack.push(value);
        } else {
          current[i] = normalizeScalar(value, decimals);
        }
      }
    } else {
      for (const key in current) {
        const value = current[key];
        if (value && typeof value === "object") {
          stack.push(value);
        } else {
          current[key] = normalizeScalar(value, decimals);
        }
      }
    }
  }

  return input;
};
